import { sortBy } from 'lodash';

import getOrgName from './getOrgName';

export default function filterOrgs({ orgs, currentOrgId, search }) {
  const query = search.trim().toLowerCase();
  const otherOrgs = orgs.filter(org => org.id !== currentOrgId);
  const matches = otherOrgs.filter(org => getOrgName(org).toLowerCase().includes(query));
  return sortBy(matches, org => getOrgName(org).toLowerCase());
}
